import React from 'react'
import { css } from '@emotion/core'
import { Paragraph, Image, Row, Cell, Grid } from '@fs/zion-ui'
import { ThingTrophy, PersonGroup } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { useChineseSurnameInfo } from '../../providers/ChineseSurnameProvider'

const colorBoxCss = (backgroundBoxColor, borderBoxColor) => css`
  background-color: ${backgroundBoxColor};
  border: 4px solid ${borderBoxColor};
  width: 100%;
`

const FactRow = ({ icon: Icon, value, label, iconColor }) => (
  <div style={{ margin: '15px' }}>
    <Row gutters="pico" alignY="middle">
      <Icon size="sm" color={iconColor} />
      <Paragraph size="lg">
        <strong aria-label={`${label}: ${value}`}>{value}</strong>
      </Paragraph>
    </Row>
    <div style={{ marginInlineStart: '30px' }} aria-hidden="true">
      <Paragraph size="xs">{label}</Paragraph>
    </div>
  </div>
)

const ChineseSurnamePopulationAndOrigins = ({ population, surnameRank, originMap, color }) => {
  const { colorValuesMap } = useChineseSurnameInfo()
  const { iconColor, backgroundBoxColor, surnameCircleColor: borderBoxColor } = colorValuesMap[color]
  const [t] = useTranslation()

  return (
    <div css={colorBoxCss(backgroundBoxColor, borderBoxColor)}>
      <Grid gutters="nano">
        <Cell columns={5}>
          <FactRow
            icon={PersonGroup}
            value={population}
            label={t('SurnamePage.surname.totalPopulation', 'Total Population')}
            iconColor={iconColor}
          />
          <FactRow
            icon={ThingTrophy}
            value={surnameRank}
            label={t('SurnamePage.surname.rank', 'Surname Rank')}
            iconColor={iconColor}
          />
        </Cell>
        <Cell columns={7}>
          <div style={{ backgroundColor: 'white' }}>
            <div style={{ marginTop: '10px' }}>
              <Paragraph centered size="sm">
                <strong>{t('SurnamePage.originMap.caption', 'Ancient Origins')}</strong>
              </Paragraph>
            </div>

            <Image
              src={originMap}
              alt={t('SurnamePage.originMap.description', 'Ancient Origins Map')}
              noCrop
              height="auto"
              width="90%"
              minHeight="150px"
              style={{ padding: '2px' }}
            />
          </div>
        </Cell>
      </Grid>
    </div>
  )
}

export default ChineseSurnamePopulationAndOrigins
